import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { ChartsService } from './services/charts-service';
import { DownloadChartsPdfService } from './services/download-charts-pdf/download-charts-pdf.service';

@Component({
  selector: 'app-operations-dashboard',
  templateUrl: './operations-page.component.html',
  providers: [
    DownloadChartsPdfService,
    ChartsService,
    ...ChartsService.providers,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OperationsComponent {
  private readonly router$ = inject(Router);

  private readonly downloadChartsPdfService$ = inject(DownloadChartsPdfService);

  public readonly charts$ = inject(ChartsService);

  public readonly loading: boolean = false;

  public readonly isDownloading = this.downloadChartsPdfService$.isDownloading;

  public downloadFilesAsPdf(): void {
    if (!this.isDownloading()) {
      this.downloadChartsPdfService$.downloadCharts(this.charts$);
    }
  }

  public handleNavigation(link: string): void {
    this.router$.navigate([link]);
  }
}
